module.exports = __webpack_public_path__ + "static/cor2-e16f13c24e6f4b6fbec2bd1066be2c18.png";